__turbopack_context__.v({
  "infoBox": "Infobox-module-scss-module__GK7ffG__infoBox",
});
